<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <transition name="fade">
    <div
      v-if="notification.show"
      :class="notification.class"
      class="notification"
    >
      <button class="delete" type="button" @click="close"></button>
      {{ notification.message }}
    </div>
  </transition>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  computed: {
    notification() {
      return this.$store.state.app.notification
    },
  },

  mounted() {
    setTimeout(() => {
      this.close()
    }, this.notification.timeout)
  },

  methods: {
    ...mapActions({
      close: 'app/setInitialNotification',
    }),
  },
}
</script>

<style lang="scss" scoped>
.notification {
  @include position(fixed, auto, 0, 2em, 0);
  padding: 1rem 2.5rem 1rem 1.5rem;
  margin: 15px auto 0;
  max-width: 350px;
  z-index: 9999;

  > .delete {
    @include position(absolute, 50%, 0.5rem, auto, auto, -50%);
  }
}
</style>
